import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';

@Feature()
export class MachineAuditFeature extends BaseToolbarFeature {
    public constructor() {
        super();
    }

    public showTemplateMachineCheck() {
        this.getAppService().editableServiceLayer?.slideMachineAuditor?.promise().then((ratingService) => {
            ratingService.showDrawer();
        });
    }
}
